import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import AboutView from "../views/AboutView"
import { useMenuState } from "../lib/hooks"
import { API_HOST } from '../lib/xhr'

const AboutPage = ({ data, location }) => {
  const model = data.strapiPage 
  const [menu_state, on_menu_button_click] = useMenuState()

  return (
    <Layout on_menu_button_click={on_menu_button_click}>
      <Seo title="About Us" image={API_HOST + model.photo.url} slug="about" />
      <AboutView model={model} menu_state={menu_state} />
    </Layout>
  )
}

export default AboutPage

export const query = graphql`
query AboutPageQuery {
  strapiPage(strapiId: {eq: 2}) {
    Body
    id
    lottiefile
    name
    panel {
      TextAlign
      body
      color
      id
      lottiefile
      name
    }
    panels {
      TextAlign
      body
      color
      id
      images {
        url
        width
        name
        mime
        height
        caption
        alternativeText
      }
      lottiefile
      name
    }
    photo {
      alternativeText
      caption
      height
      id
      mime
      size
      url
      formats {
        thumbnail {
          url
        }
      }
    }
    profile {
      id
      linkedin
      name
      title
      photo {
        url
      }
    }
  }
}
`
